export default "__VITE_ASSET__CNesLdfJ__"